// Summary consent — the device-local mirror of the Author's semantic-summary
// opt-in (Workspace.summaryConsent, default off; IDD 94442b9d).
//
// Same split as `displayName.ts`: the TRUE intent travels to the domain via
// the `setSummaryConsent` command (so the agent/PM can gate on it), but
// `GET /state` does not yet read `workspace.summaryConsent` back to the
// client (no App-layer read method exists for it either — flagged in the
// implementation report, not faked here). Until that read path lands, this
// device preference (localStorage, like the theme —
// memory project_theme_outside_event_log) is the only thing the UI can
// honestly show as "on"/"off": it is what THIS browser last told the
// domain, not a guarantee the domain still agrees (e.g. a second device
// toggling it would not reach here).
//
// Default OFF (`false`), matching the domain default — a fresh device with
// no local write yet reads as consent-off, never a false "on".

import { readDeviceKey, writeDeviceKey } from "./deviceStore.js";

const STORAGE_KEY = "bilda.summaryConsent";

export const readSummaryConsent = (): boolean =>
    readDeviceKey(STORAGE_KEY) === "true";

export const writeSummaryConsent = (consented: boolean): void =>
    writeDeviceKey(STORAGE_KEY, consented ? "true" : "false");
